export const ERROR_REQUIRED = 'required';
export const ERROR_INVALID_FORMAT = 'invalid';
export const ERROR_UPLOADING_INVALID_TYPE = 'uploadingInvalidType';
export const ERROR_UPDATE_RSVP_UNAVAILABLE = 'updateRsvpUnavailable';
export const ERROR_RSVP_CLOSED = 'rsvpClosed';
export const ERROR_RSVP_MAX = 'rsvpMax';
export const ERROR_INVITE_ONLY = 'inviteOnly';
export const ERROR_DEFAULT_SUBMISSION = 'submission';
export const ERROR_EMAIL_DOMAIN_RESTRICTED = 'emailDomainRestricted';
export const ERROR_DUPLICATE_EMAIL = 'duplicateEmail';
export const ERROR_CAPTCHA_DATADOME = 'captchaDatadome';
export const ERROR_SERVER_DEFAULT = 'defaultServerError';

export const ERROR_QUESTION_RESPONSE_LIMIT = 'FormLogicRuleLimitValidator';

export const getDefaultRequiredMessage = (label) => `The question "${label}" is required.`;
export const getDefaultInvalidResponseFormatMessage = (label) => `The question "${label}" has invalid format.`;

export const SERVER_ERROR_MESSAGE = 'Sorry, there was an error with the server. Please try again';
const DEFAULT_UPDATE_RSVP_UNAVAILABLE_MESSAGE = 'Sorry, updating your responses for this event is no longer enabled.';
const DEFAULT_RSVP_CLOSED_MESSAGE = 'Sorry, this event is no longer accepting RSVPs.';
const DEFAULT_RSVP_MAX_MESSAGE = 'Sorry, that email address has already been used to RSVP to this event.';
const DEFAULT_INVITE_ONLY_MESSAGE = 'Sorry, only guests invited to this event can RSVP.';
const DEFAULT_GENERIC_SUBMISSION_MESSAGE =
    'There were some errors submitting the form. Please make sure all questions are correctly answered.';
const DEFAULT_GENERIC_EMAIL_DOMAIN_RESTRICTED_MESSAGE = 'Sorry, you cannot RSVP to this event with this email';
const DEFAULT_DUPLICATE_EMAIL_MESSAGE = 'This email has already been used for a ticket.';
export const DEFAULT_CAPTCHA_DATADOME_MESSAGE =
    'Thank you for completing the security check, please re-submit your form.';

export const getGenericSubmissionErrorMessage = (errorMessages) =>
    errorMessages[ERROR_DEFAULT_SUBMISSION] || DEFAULT_GENERIC_SUBMISSION_MESSAGE;

export const DEFAULT_REQUIRED = {
    label: 'Required Question',
    value: getDefaultRequiredMessage('[label]'),
};
export const DEFAULT_INVALID = {
    label: 'Invalid Response Format',
    value: getDefaultInvalidResponseFormatMessage('[label]'),
};
export const DEFAULT_UPLOADING_INVALID_TYPE = {
    label: 'Invalid File Type',
    value: 'Error uploading the file: Invalid file type.',
};
export const DEFAULT_UPDATE_RSVP_UNAVAILABLE = {
    label: 'Updating Responses Disabled',
    value: DEFAULT_UPDATE_RSVP_UNAVAILABLE_MESSAGE,
};
export const DEFAULT_RSVP_CLOSED = {
    label: 'Not Accepting RSVPs',
    value: DEFAULT_RSVP_CLOSED_MESSAGE,
};
export const DEFAULT_RSVP_MAX = {
    label: 'RSVP Limit',
    value: DEFAULT_RSVP_MAX_MESSAGE,
};
export const DEFAULT_INVITE_ONLY = {
    label: 'Not on Guest List',
    value: DEFAULT_INVITE_ONLY_MESSAGE,
};
export const DEFAULT_EMAIL_DOMAIN_RESTRICTION = {
    label: 'Email Domain Restriction',
    value: DEFAULT_GENERIC_EMAIL_DOMAIN_RESTRICTED_MESSAGE,
};
export const DEFAULT_GENERIC_SUBMISSION = {
    label: 'Generic Form Error Message',
    value: DEFAULT_GENERIC_SUBMISSION_MESSAGE,
};
export const DEFAULT_DUPLICATE_EMAIL = {
    label: 'Duplicate Email',
    value: DEFAULT_DUPLICATE_EMAIL_MESSAGE,
};

export const getErrorMessages = (flags) => ({
    [ERROR_REQUIRED]: DEFAULT_REQUIRED,
    [ERROR_INVALID_FORMAT]: DEFAULT_INVALID,
    [ERROR_UPLOADING_INVALID_TYPE]: DEFAULT_UPLOADING_INVALID_TYPE,
    [ERROR_UPDATE_RSVP_UNAVAILABLE]: DEFAULT_UPDATE_RSVP_UNAVAILABLE,
    [ERROR_RSVP_CLOSED]: DEFAULT_RSVP_CLOSED,
    [ERROR_RSVP_MAX]: DEFAULT_RSVP_MAX,
    [ERROR_INVITE_ONLY]: DEFAULT_INVITE_ONLY,
    ...(flags.formEmailDomainRestriction && {
        [ERROR_EMAIL_DOMAIN_RESTRICTED]: DEFAULT_EMAIL_DOMAIN_RESTRICTION,
    }),
    [ERROR_DEFAULT_SUBMISSION]: DEFAULT_GENERIC_SUBMISSION,
    [ERROR_DUPLICATE_EMAIL]: DEFAULT_DUPLICATE_EMAIL,
});

export const DEFAULT_SERVER_MESSAGES = {
    [ERROR_UPDATE_RSVP_UNAVAILABLE]: DEFAULT_UPDATE_RSVP_UNAVAILABLE_MESSAGE,
    [ERROR_RSVP_CLOSED]: DEFAULT_RSVP_CLOSED_MESSAGE,
    [ERROR_RSVP_MAX]: DEFAULT_RSVP_MAX_MESSAGE,
    [ERROR_INVITE_ONLY]: DEFAULT_INVITE_ONLY_MESSAGE,
    [ERROR_CAPTCHA_DATADOME]: DEFAULT_CAPTCHA_DATADOME_MESSAGE,
    [ERROR_SERVER_DEFAULT]: SERVER_ERROR_MESSAGE,
};

export const getMessage = (errorKey, customErrors, flags) =>
    customErrors[errorKey] || getErrorMessages(flags)[errorKey];
